module.exports = __webpack_public_path__ + "static/media/logout-icon.3c7fa9ab.svg";